import { Component, ElementRef, Input, ViewChild } from '@angular/core';

@Component({
  selector: 'app-digilocker',
  templateUrl: './digilocker.component.html',
  styleUrls: ['./digilocker.component.scss']
})
export class DigilockerComponent {
  @Input() digiURL: any;
  @ViewChild('iframe') iframe!: ElementRef;
  ngAfterViewInit() {
    this.openFrame();
  }
  openFrame(){
    this.iframe.nativeElement.src = this.digiURL.kycUrl;
  }
}
